<template>
  <transition class="agenda">
    <LoadingScreen v-if="agendaLoading && firstLoad"></LoadingScreen>
    <div v-if="users && dates && grid">
      <div class="row">
        <div class="col pl-5">
          <div class="btn btn-success btn" @click="selectedUser = false" v-if="selectedUser">Back</div>
        </div>
      </div>
      <div class="row p-5 mb-5" v-show="selectedUser">
        <div class="col">
          <div class="row user">
            <div class="col-auto">
              <div class="photo">
                <img :src="selectedUser.photo" alt="">
              </div>
            </div>
            <div class="col align-self-center">
              <span class="bold m--icon-font-size-lg1">{{ selectedUser.name }}</span>
              <div>
                {{ selectedUser.tagline }}
              </div>
            </div>
          </div>
          <div class="row pt-5">
            <h5>Utilization</h5>
            <div class="progress" style="width:100%;">
              <div class="progress-bar progress-bar-success" role="progressbar" v-bind:style="{ width: item.percentage + '%', background: item.color }" v-for="item in utilizationArray">
                <!--{{ item.client }}-->
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-auto" v-for="item in utilizationArray">
                <span v-bind:style="{background: item.color }" style="width:10px; height:10px;" class="m-badge m-badge--dot"></span>
                <span class="bold ml-1">{{ Math.round(item.percentage) }}%</span>
                {{ item.client }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto align-self-center">
          <vue-circle
            ref="bookedPercentage"
            :progress="0"
            :reverse="false"
            line-cap="round"
            :fill="{ gradient: ['yellow', 'cyan'] }"
            empty-fill="rgba(0, 0, 0, .1)"
            :animation-start-value="0.0"
            :start-angle="11"
            insert-mode="append"
            :thickness="5"
            :show-percent="true">
            <p>Booked</p>
          </vue-circle>
        </div>
      </div>

      <div class="row fixed-datebar pt-3 pb-3 pl-0 pr-0">
        <div class="assets col-1 sm-hide" v-if="!selectedUser ">
          <div style="height:100%; padding-top:5px;" class="mx-1">
            <i class="fas fa-sync" :class="{'fa-spin' : agendaLoading}"></i> {{ !agendaLoading ? agendaReloadCountdown : '&nbsp;&nbsp;&nbsp;&nbsp;' }}
          </div>
          <div class="btn btn-metal btn-sm mx-1" @click="$refs.arrangement.open()">
            <i class="fas fa-users"></i>
          </div>
          <div class="btn btn-metal btn-sm mx-1" @click="resetDateOffset()">
            <i class="fa fa-calendar"></i>
          </div>
        </div>
        <div class="col pl-0 sm-hide" :class="{'bold' : today.format('DD') == date.format('DD')}" v-for="date, date_index in dates">
          <div class="row p-0 m-0" style="height:100%;">
            <div class="col-auto p-0 align-self-center"> {{ date.format('MMM-DD ddd') }}</div>
            <div class="col text-right pr-0 weeksArrows" v-if="date_index + 1 == dates.length">
              <div class="btn btn-metal btn-sm mr-1" @click="decrementDateOffset(7)"><<</div>
              <div class="btn btn-metal btn-sm" @click="incrementDateOffset(7)">>></div>
            </div>
          </div>
        </div>
        <div class="col sm-show">
          <div class="row">
            <div class="col-auto">
              <div class="btn btn-metal btn-sm mr-1" @click="decrementDateOffset(1)"><<</div>
            </div>
            <div class="col text-center"
                 style="align-self: center;"
                 @click="setDateOffset()"
                 :class="{'bold' : today.format('DD') == date.format('DD')}"
                 v-for="date, date_index in dates">
              {{ date.format('MMM-DD dddd') }}
            </div>
            <div class="col-auto">
              <div class="btn btn-metal btn-sm" @click="incrementDateOffset(1)">>></div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top:50px;"></div>
      <div v-show="agendaInnerLoading" class="agenda-cover">
        <LoadingScreen></LoadingScreen>
      </div>

      <div class="row calendar-row" :class="{'user-selected': selectedUser}" v-for="row in grid" v-if="(selectedUser && selectedUser.id == row.user.id) || !selectedUser">

        <!--USER-->
        <div class="col-1 pt-3 pb-3 user-col sm-hide" v-if="!selectedUser">

          <div class="row user" @click="updateSelectedUser(row.user)">
            <div class="col-auto">
              <div class="photo">
                <img :src="row.user.photo" alt="">
              </div>
              <div>
                {{ row.user.name }}
              </div>
              <div style="max-width:65px;">
                {{ row.user.tagline }}
              </div>
            </div>
          </div>

        </div>

        <!--DATA-->
        <div class="col calendar-col" v-for="column in row.columns" style="min-height: 200px;">

          <div class="header" :class="{'red' : column.booking < 0}">
            <div class="booking-info" v-if="column.booking < 0">
              {{ secondsToTimestring(column.booking) }} Overbooked
              <span class="sm-show pl-2"> -- <span class="font-weight-bold">{{ row.user.name }}</span></span>
            </div>
            <div class="booking-info" v-if="column.booking >= 0">
              {{ secondsToTimestring(column.booking) }} Left
              <span class="sm-show pl-2"> -- <span class="font-weight-bold">{{ row.user.name }}</span></span>
            </div>

            <div class="new-task btn mb-2 btn-sm" @click="$refs.taskForm.create(row.user.id, column.date)">
              <i class="fa fa-plus"></i>
            </div>
          </div>

          <draggable v-model="column.tasks" class="dragArea" :user_id="row.user.id" :date="column.date.format('YYYY-MM-DD')" :options="{ghostClass: 'ghost', group:'tasks', draggable: !screenSm ? '.draggable' : ''}" @end="taskUpdated">
            <div class="task draggable"
                 :class="{
                'task-done' : task.done,
                'task-done-confirmed' : task.done_confirmed,
                'parent-overlay' : overlayParent == task.id,
                'parent-border' : !task.parent_id && task.fixed_price,
                'border-danger' : isDeadlineMissed(task),
                'task-meeting-search': foundTasks && foundTasks.isFound(task)
               }"
                 v-for="task in column.tasks"
                 :key="task.id"
                 :task_id="task.id"
                 @click="$refs.viewTask.open(task.id)"
                 @mouseover="overlayParent = task.parent_id"
                 @mouseout="overlayParent = null"
            >
              <div class="task-not-meeting-search" v-if="foundTasks && !foundTasks.isFound(task)"></div>
              <div class="row position-relative">
                <div class="col-auto pr-0 align-self-center">
                  {{ secondsToTimestring(task.duration) }} <br>
                  <template v-if="(isManager || isAdmin) && task.done_confirmed">
                    <div style="width: 100%; border-top: 1px solid #D0D3CF;" class="my-1"></div>
                    <i class="fas fa-money-bill-alt"></i> <strong>{{ billed(task) }}</strong>
                  </template>
                  <template v-if="(isManager || isAdmin) && task.done && !task.done_confirmed">
                    <div style="width: 100%; border-top: 1px solid #D0D3CF;" class="my-1"></div>
                    <i class="fas fa-wrench"></i> <strong>{{ secondsToTimestring(task.engineering_hours) }}</strong>
                  </template>
                </div>
                <div class="col align-self-center">
                  <div class="bold">
                    {{ task.client.name }}
                    <span v-if="task.fixed_price">($)</span>
                    <i class="far fa-sticky-note" v-if="hasComments(task)"></i>
                    <i class="far fa-comments" v-if="hasUserComments(task)"></i>
                  </div>
                  <div>{{ task.project.name }}</div>
                </div>
                <div class="col-auto align-self-center mr-2" style="font-weight: bolder;">
                  <span v-if="task.deadline">
                    {{ momentClass(task.deadline).format('MMM-D') }}
                    <br/>
                    {{ momentClass(task.deadline).format('HH:mm') }}
                    <br>
                  </span>
                  <b v-if="task.pvsyst_2d">{{ task.pvsyst_2d }}x 2D Pvsyst <br> </b>
                  <b v-if="task.pvsyst_3d">{{ task.pvsyst_3d }}x 3D Pvsyst</b>
                </div>

                <div class="action-buttons"
                     :class="{
                      'selected-task': multiSelection.isChecked(task)
                     }">
                  <div class="multiple-select action-button"
                       @click.stop="multiSelection.toggleCheck(task)">
                    <i class="far"
                       :class="{
                         'fa-square': !multiSelection.isChecked(task),
                         'fa-check-square': multiSelection.isChecked(task)
                       }"></i>
                  </div>
                  <div class="copy-button action-button" @click.stop="copyTask(task.id)">
                    <i class="far fa-copy"></i>
                  </div>
                </div>

                <div class="overlay-div" v-if="overlayParent == task.id">
                  <!--Parent task-->
                </div>

              </div>
            </div>
          </draggable>

        </div>
      </div>

      <task-form ref="taskForm"
                 @taskCreated="task => { this.addTaskToUser(task.user_id, task, true) }"
                 @taskUpdate="task => { this.updateTaskInUser(task.user_id, task, true) }"
      ></task-form>
      <view-task ref="viewTask"
                 @updateTask="$refs.taskForm.edit($event)"
                 @taskDeleted="task => { this.removeTaskFromUser(task.user_id, task.id, true) }"
                 @taskUndone="task => { this.updateTaskInUser(task.user_id, task, true) }"
      ></view-task>
      <billable-hours ref="billableHours"
                      @backToTask="$refs.viewTask.open($event)"
      ></billable-hours>
      <arrangement ref="arrangement"
                   :user="user"
                   :users="users"
                   @agendaArrangementUpdated="onAgendaArrangementUpdated($event)"
      ></arrangement>
    </div>
  </transition>
</template>
<script>
  import moment from 'moment'
  import draggable from 'vuedraggable'
  import $ from 'jquery'
  import VueCircle from 'vue2-circle-progress'
  import Colors from '../../components/colors'

  import CreateTask from './CreateTask.vue'
  import ViewTask from './ViewTask.vue'
  import BillableHours from './BillableHours.vue'
  import Arrangement from './Arrangement.vue'
  import LoadingScreen from '../../components/LoadingScreen.vue'

  import MultipleSelect from './MultipleSelect'
  import SearchedTasksArray from './SearchedTasksArray'
  import {mapGetters, mapActions} from 'vuex'

  export default {
    components: {
      ViewTask,
      draggable,
      'task-form': CreateTask,
      'view-task': ViewTask,
      VueCircle,
      'billable-hours': BillableHours,
      Arrangement,
      LoadingScreen
    },


    created() {
      this.$root.$on('taskBilled', this.taskBilled)
      this.$root.$on('search.searching', this.onSearching)
      this.$root.$on('search.clear', () => this.foundTasks = null)
      this.$root.$on('load-agenda', () => this.loadAgenda())

      if (this.screenSm) {
        this.dateOffset = 0
      }

      this.loadAgenda()
    },
    data() {
      return {
        users: false,
        dates: false,
        grid: false,
        dateOffset: (0 - moment().day()) + 1,
        today: moment(),
        momentClass: moment,
        selectedUser: false,
        utilizationArray: [],
        overlayParent: null,
        agendaReloadCountdown: 60,
        agendaReloadInterval: null,
        agendaReloadIntervalPaused: false,
        agendaLoading: true,
        firstLoad: true,
        checkedTasks: [],
        multiSelection: new MultipleSelect(this),
        foundTasks: null,
        agendaInnerLoading: false,
      }
    },

    watch: {
      checkedTasks: function (value) {
        if (value.length > 0) {
          this.agendaReloadIntervalPaused = true
        } else {
          this.agendaReloadIntervalPaused = false
        }
      }
    },

    computed: {
      ...mapGetters('auth', ['isManager', 'isAdmin', 'user']),
      screenSm() {
        return screen.width <= 576
      },
      daysToShow() {
        return this.screenSm ? 1 : 5
      },
    },
    methods: {
      ...mapActions('auth', ['setUser']),

      onSearching(text) {
        if (!text) {
          this.foundTasks = null
          return
        }

        let tasks = []
        this.getArrangedUsers().forEach(user => tasks = tasks.concat(user.tasks))
        this.foundTasks = new SearchedTasksArray(tasks, text)
      },

      billed(task) {
        if (task.fixed_price)
          return task.fixed_price + '€'

        return this.secondsToTimestring(task.billable_hours_confirmed);
      },

      runAgendaAutoloading() {
        this.agendaReloadInterval = setInterval(() => {
          if (!this.agendaReloadIntervalPaused) {
            this.agendaReloadCountdown--
            if (this.agendaReloadCountdown === 0) {
              this.loadAgenda()
            }
          }
        }, 1000)
      },
      loadAgenda() {
        this.agendaLoading = true
        this.agendaInnerLoading = true
        this.axios.get('/users?agenda=true&date_offset=' + this.dateOffset + '&days_to_load=' + this.daysToShow)
          .then(res => {
            this.users = res.data.data;
            this.generateDatesAndGrid()

            this.agendaReloadCountdown = 60
            clearInterval(this.agendaReloadInterval)
            this.runAgendaAutoloading()

            this.firstLoad = false
            this.agendaLoading = false
            this.agendaInnerLoading = false

            if (this.selectedUser) {
              this.updateSelectedUser(this.users.find(u => u.id === this.selectedUser.id))
            }

            this.$root.$emit('agenda-loaded');
          })
      },
      //GENERATE GRID
      generateGrid() {
        if (!this.users)
          return

        this.grid = [];
        const arrangedUsers = this.getArrangedUsers()

        //Each user is a row
        arrangedUsers.forEach(user => {
          const row = {
            user: user,
            columns: [],
          }

          //Each date is a column
          this.dates.forEach(date => {
            const tasks = this.tasksByDate(user.tasks, date)
            const column = {
              date: date,
              tasks,
              booking: this.calculateTaskBooking(tasks)
            }

            row.columns.push(column)
          })

          if (!row.user.hide_from_dashboard) {
            this.grid.push(row)
          }
        })

        if (this.selectedUser) {
          this.updateSelectedUser();
        }

        this.$forceUpdate()
      },
      generateDatesAndGrid() {
        this.dates = [];
        for (let i = this.dateOffset; i < this.dateOffset + this.daysToShow; i++)
          this.dates.push(
            moment().add(i, 'd')
          )

        this.generateGrid()
      },

      incrementDateOffset(c = 1) {
        this.dateOffset += c
//        this.generateDatesAndGrid()
        this.loadAgenda()
      },
      decrementDateOffset(c = 1) {
        this.dateOffset -= c
//        this.generateDatesAndGrid()
        this.loadAgenda()
      },
      resetDateOffset() {
        this.dateOffset = (0 - moment().day()) + 1;
//        this.generateDatesAndGrid()
        this.loadAgenda()
      },
      setDateOffset(c = 0) {
        this.dateOffset = c;
//        this.generateDatesAndGrid()
        this.loadAgenda()
      },

      //Task drop event
      taskUpdated(event) {
        let from = event.from
        let to = event.to
        let item = event.item

        let columnItemsTo = event.to.children
        let columnItemsFrom = event.from.children

        let fromUserId = from.getAttribute('user_id')
        let toUserId = to.getAttribute('user_id')
        let taskId = item.getAttribute('task_id')


        let fromDate = from.getAttribute('date')
        let toDate = to.getAttribute('date')

        let task = this.getTaskFromUser(fromUserId, taskId)

        if (fromDate !== toDate) {
          task.date = toDate
        }


        if (toUserId !== fromUserId) {
          //move task to another user
          this.removeTaskFromUser(fromUserId, taskId)
          this.addTaskToUser(toUserId, task);
        } else {
          //update task in current user
          this.updateTaskInUser(toUserId, task)
        }

        this.redoOrderingForColumnItems(toUserId, columnItemsTo);
        this.redoOrderingForColumnItems(fromUserId, columnItemsFrom);

        //update all affected tasks
        let tasks = []
        $.each($(columnItemsFrom), (key, val) => {
          let task_id = $(val).attr('task_id')
          tasks.push(
            this.getTaskFromUser(fromUserId, task_id)
          )
        })
        $.each($(columnItemsTo), (key, val) => {
          let task_id = $(val).attr('task_id')
          tasks.push(
            this.getTaskFromUser(toUserId, task_id)
          )
        })

        let data = {
          tasks,
          fields: [
            'user_id',
            'order_id',
            'date',
          ]
        }

        this.axios.post('/tasks/updateMultiple', data).then(response => {
          if (response.status === 202) {
            //good
          } else {
            //error
          }
        })


        this.$forceUpdate()
        this.generateGrid();

      },

      taskBilled(task) {
        this.$root.$emit('bill-success', task)
        this.updateTaskInUser(task.user_id, task, true)
      },

      updateTaskInUser(user_id, task, redraw = false) {
        user_id = parseInt(user_id)

        for (let user_key in this.users) {
          let user = this.users[user_key]
          if (user.id === user_id) {

            for (let task_key in user.tasks) {
              let user_task = user.tasks[task_key]

              if (user_task.id === task.id) {
                this.users[user_key]['tasks'][task_key] = task
              }

            }

          }
        }

        if (redraw) {
          this.generateGrid()
        }

      },
      addTaskToUser(user_id, task, redraw = false) {
        user_id = parseInt(user_id)

        for (let user_key in this.users) {
          let user = this.users[user_key]
          if (user.id === user_id) {
            task.user_id = user.id //set task user_id to new user_id
            this.users[user_key].tasks.push(task)
          }
        }

        if (redraw) {
          this.generateGrid()
        }


      },
      removeTaskFromUser(user_id, task_id, redraw = false) {
        user_id = parseInt(user_id)
        task_id = parseInt(task_id)

        for (let user_key in this.users) {
          let user = this.users[user_key]
          if (user.id === user_id) {

            for (let task_key in user.tasks) {
              let task = user.tasks[task_key]

              if (task.id === task_id) {

                this.users[user_key].tasks.splice(task_key, 1)

              }

            }

          }
        }

        if (redraw) {
          this.generateGrid()
        }

      },
      redoOrderingForColumnItems(user_id, tasks) {
        user_id = parseInt(user_id)
        $.each($(tasks), (key, val) => {
          let task_id = $(val).attr('task_id')
          let task = this.getTaskFromUser(user_id, task_id)
          task.order_id = key
        })
      },

      copyTask(task_id) {
        this.axios.post('tasks/copy/' + task_id).then(response => {
          let task = response.data.data
          this.addTaskToUser(task.user_id, task, true)
          this.$root.$emit('task-copied', moment(task.date).format('MMM-DD ddd'))
        }).catch(err => {
        });
      },

      getTaskFromUser(user_id, task_id) {
        user_id = parseInt(user_id)
        task_id = parseInt(task_id)

        for (let user_key in this.users) {
          let user = this.users[user_key]
          if (user.id === user_id) {

            for (let task_key in user.tasks) {
              let task = user.tasks[task_key]

              if (task.id === task_id) {
                return task
              }

            }

          }
        }

      },
      getUserById(user_id) {
        user_id = parseInt(user_id)
        for (let user_key in this.users) {
          let user = this.users[user_key]
          if (user.id === user_id) {
            return user
          }
        }
      },
      tasksByDate(tasks, date) {
        let filtered = [];

        for (let task_key in tasks) {
          let task = tasks[task_key];

          let task_date = moment(task.date).format('YYYY-MM-DD')
          if (task_date === date.format('YYYY-MM-DD')) {
            filtered.push(task)
          }

        }

        //sort tasks by order_id
        filtered.sort(function (a, b) {
          return a.order_id - b.order_id;
        });

        return filtered

      },
      calculateTaskBooking(tasks) {
        let total = 0;
        for (let task_key in tasks) {
          let task = tasks[task_key]
          total += task.duration
        }

        // 8 hours in seconds is 28800
        let booking = 28800 - total

        return booking
      },
      secondsToTimestring(seconds) {

        seconds = Math.abs(seconds) / 3600

        let hours = Math.floor(seconds);
        let minutesRaw = seconds - hours;
        let minutes = Math.round(60 * minutesRaw);
        if (minutes === 60) {
          hours++;
          minutes = 0;
        }

        return this.leadingZero(hours) + ':' + this.leadingZero(minutes);
      },
      getTaskKey(user, task_id) {
        for (let task_key in user.tasks) {
          let task = user.tasks[task_key]

          if (task.id === task_id) {

            return task_key

          }

        }
      },
      updateSelectedUser(user = false) {
        if (user) {
          this.selectedUser = user
        }
        this.setBookedPercentageByUser()
        this.setUtilizationArray()
      },
      setBookedPercentageByUser() {
        let user = this.selectedUser
        let totalTime = 0;
        let days = 0;
        for (let date_key in this.dates) {
          let tasks = this.tasksByDate(user.tasks, this.dates[date_key])
          days++
          if (tasks.length > 0) {
            for (let task_key in tasks) {
              totalTime += tasks[task_key].duration
            }
          }
        }
        let percentage = totalTime / (days * 8 * 3600) * 100
        this.$refs.bookedPercentage.updateProgress(percentage)
      },
      setUtilizationArray() {
        const clientsTime = {}
        const colors = new Colors()
        let totalMinutes = 0

        this.dates.forEach(date =>
          this.tasksByDate(this.selectedUser.tasks, date)
            .forEach(task => {
              totalMinutes += task.duration / 60
              if (clientsTime[task.client.name])
                clientsTime[task.client.name] += task.duration / 60
              else
                clientsTime[task.client.name] = task.duration / 60
            }))

        this.utilizationArray = []
        Object.keys(clientsTime).forEach(clientName => {
          this.utilizationArray.push({
            client: clientName,
            percentage: clientsTime[clientName] * 100 / totalMinutes,
            color: colors.getColor()
          })
        })
      },

      leadingZero(number) {
        return number > 9 ? '' + number : '0' + number;
      },

      fakeObject(c) {
        let arr = [];
        for (let i = 0; i < c; i++) {
          arr.push(null);
        }
        return arr
      },

      isDeadlineMissed(task) {
        if (!task.deadline) return false

        if (moment(task.deadline).isBefore(moment())) {
          return true
        }
      },

      hasComments(task) {
        return task.notes;
      },
      hasUserComments(task) {
        return task.comments.length > 0
      },

      onAgendaArrangementUpdated(agendaArrangement) {
        this.user.agendaArrangement = agendaArrangement
        this.setUser(this.user)

        this.generateGrid()
      },

      getArrangedUsers() {
        if (!this.users)
          return []

        const usersToArrange = this.users.slice(0)
        const arrangement = this.user ? JSON.parse(this.user.agendaArrangement) || [] : []
        const arrangedUsers = []

        arrangement.forEach(piece => {
          const user = usersToArrange.find(user => {
            return piece.userId === user.id
          })

          if (!user) {
            return
          }

          if (piece.show)
            arrangedUsers.push(user)

          const i = usersToArrange.indexOf(user);
          if (i > -1)
            usersToArrange.splice(i, 1);
        })

        return arrangedUsers.concat(usersToArrange)
      }
    }
  }
</script>
<style lang="scss">
  $user-background-odd: #404040;
  $user-background-even: #4e4e4e;
  $border-color: #dbdbdb;
  $calendar-odd-color: #d5d5d5;
  $calendar-even-color: #e9e9e9;
  $green: #34bfa3;
  $red: #f4516c;

  .fixed-datebar {
    position: fixed;
    background: #f2f3f8;
    padding: 10px;
    width: 100%;
    z-index: 9;
    margin-top: -1px;
  }

  .bold {
    font-weight: bold;
  }

  .calendar-row {
    &:last-child {
      border-bottom: 1px solid $border-color;
    }

    .user-col {
      border-top: 1px solid $border-color;
      background: $user-background-even;
    }

    background: $calendar-even-color;
    &:nth-child(odd) {
      background: $calendar-odd-color;

      .user-col {
        background: $user-background-odd;
      }

    }

    &.user-selected {
      background: $calendar-even-color;

      margin-left: 0px !important;
      border-left: 1px solid $border-color;
      border-bottom: 1px solid $border-color;
    }

    /*color:white;*/

  }

  .calendar-col {
    border-top: 1px solid $border-color;
    border-right: 1px solid $border-color;
    padding: 10px;

    .task {
      position: relative;
      padding: 5px;
      margin-top: 2px;
      background: white;
      color: black;
      cursor: pointer;
      border: 1px solid #ccc;

      &.task-done {
        background: #f4efb5;
        .bold {
          text-decoration: line-through;
        }
      }
      &.task-done-confirmed {
        background: transparent;
        .bold {
          text-decoration: line-through;
        }
      }

      &.parent-overlay {
        .overlay-div {
          position: absolute;
          width: calc(100% - 21px);
          height: calc(100% + 10px);
          top: -5px;
          left: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          font-size: 2rem;
          font-weight: bold;
          /*background: rgba(0, 0, 0, 0.7);*/
          background: transparent;
          border: 2px solid #00e500;
        }
      }
      &.parent-border {
        border: 2px solid #00e500;
      }

      .action-buttons {
        position: absolute;
        height: calc(100% + 10px);
        right: 10px;
        top: -5px;
        display: flex;
        width: 10px;
        -webkit-transition: width 0.15s;
        transition: width 0.15s;
        .far {
          font-size: 0;
        }
      }

      .action-buttons:hover, .selected-task {
        width: 100px;
        .far {
          font-size: 1.5rem;
        }
      }

      .selected-task .multiple-select {
        background-color: #9A5D91 !important;
      }

      .action-button {
        width: 50%;
        height: 100%;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .copy-button {
        background: $green;
      }

      .multiple-select {
        background: #ADAFC6;
      }
    }
    .header {
      display: flex;

      &.red {
        .btn {
          margin-bottom: 0 !important;
          margin-left: 0;
          border-radius: 0 2px 2px 0;
          background: $red;
          color: white;

          &:hover {
            background: $red;
            border: 1px solid $red;
          }
        }
        .booking-info {
          background: $red;
          padding-left: 5px;
          color: white;
          flex-basis: 100%;
          border-radius: 2px 0 0 2px;
          display: flex;
          align-items: center;
        }
      }

      .btn {
        margin-bottom: 0 !important;
        margin-left: 0;
        border-radius: 0 2px 2px 0;
        background: $green;
        color: white;

        &:hover {
          background: $green;
          border: 1px solid $green;
        }
      }
      .booking-info {
        background: $green;
        padding-left: 5px;
        color: white;
        flex-basis: 100%;
        border-radius: 2px 0 0 2px;
        display: flex;
        align-items: center;
      }

    }

  }

  .user-col {
    .user {
      cursor: pointer;
      color: white;
    }
  }

  .photo {
    width: 65px;
    height: 65px;
    border-radius: 120px;
    overflow: hidden;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .dragArea {
    height: calc(100% - 37px);
  }

  .ghost {
    opacity: .5;
    background: #C8EBFB;
  }

  .weeksArrows {
    display: flex;
    justify-content: center;
    align-content: center;
  }

  .assets {
    display: flex;
  }

  .task-meeting-search {
    transform: scale(1.05);
    border: 2px solid #827CD0 !important;
  }

  .task-not-meeting-search {
    background-color: black;
    position: absolute;
    z-index: 5;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.6;
  }

  .agenda-cover {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 99;
  }

  @media (max-width: 576px) {
    .agenda {
      &.m-content {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }

      .fixed-datebar {
        position: fixed;
        margin: 0;
        margin-top: -1px;
      }

      .calendar-col {
        .header, .dragArea {
          padding-left: 20px;
          padding-right: 20px;
        }

        .action-buttons {
          display: none;
        }
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/agenda/Index.vue